// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-48a1c054] {\n  color: #fff;\n  font-size: 14px;\n  background-color: #da4d4d;\n  padding: 8px 20px;\n  border-radius: 15px;\n}", ""]);
// Exports
module.exports = exports;
